import { render } from "./VendorLeadsInfo.vue?vue&type=template&id=99123144"
import script from "./VendorLeadsInfo.vue?vue&type=script&lang=js"
export * from "./VendorLeadsInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__